import React, { useEffect, useState, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import { fetchApi } from "../../services/requests";
import CheckboxElement from "../FormsElements/CheckboxElement";
import { useClickOutside } from "../../hooks/useClickOutside";
import Cookies from "js-cookie";

const Modal = ({
  setActiveModal,
  setFirstCookieAgreement,
  firstCookieAgreement,
  setSecondCookieAgreement,
}) => {
  const modalRef = useRef(null);
  const modalContainerRef = useRef(null);
  const [modalTopContent, setModalTopContent] = useState(null);
  const [modalBottomContent, setModalBottomContent] = useState(null);

  const [checkboxAccepted, setCheckboxAccepted] = useState(() =>
    Boolean(Cookies.get("cookie_third_party"))
  );
  const [checkboxData, setCheckboxData] = useState(true);
  useClickOutside(modalContainerRef, () => setActiveModal(false));

  useEffect(() => {
    const getModalContent = async () => {
      const [data] = await fetchApi({ url: "blocks-block/234" });
      setModalTopContent(data);
      const [checkboxData] = await fetchApi({ url: "blocks-block/235" });
      setCheckboxData(checkboxData);
      const [dataBottom] = await fetchApi({ url: "blocks-block/236" });
      setModalBottomContent(dataBottom);
    };
    getModalContent();
  }, []);

  useEffect(() => {
    if (firstCookieAgreement === true) {
      setCheckboxAccepted(true);
    } else {
      setCheckboxAccepted(false);
    }
  }, [firstCookieAgreement]);

  useEffect(() => {
    if (modalTopContent) {
      const modalElement = modalRef.current;
      const acceptedText = modalElement.querySelector(
        ".cookies-modal__info--accepted"
      );
      const notAcceptedText = modalElement.querySelector(
        ".cookies-modal__info--notaccepted"
      );
      if (checkboxAccepted === true) {
        acceptedText.style.display = "block";
        notAcceptedText.style.display = "none";
      } else {
        notAcceptedText.style.display = "block";
        acceptedText.style.display = "none";
      }
    }
  }, [checkboxAccepted, modalTopContent]);

  const closeModal = (e) => {
    e.preventDefault();
    setFirstCookieAgreement(checkboxAccepted);
    setActiveModal(false);
    setSecondCookieAgreement(true);
  };

  return (
    <div className="terms-modal terms-modal--active" id="cookie-modal">
      <div className="terms-modal__content" ref={modalContainerRef}>
        <p className="terms-modal__close" onClick={() => setActiveModal(false)}>
          &#10005;
        </p>
        <div className="cookies-modal" ref={modalRef}>
          {modalTopContent ? (
            ReactHtmlParser(modalTopContent.content)
          ) : (
            <p>Ładowanie</p>
          )}
          <form className="cookies-form" action="#">
            <div className="cookies-modal__form-row">
              <CheckboxElement
                label={ReactHtmlParser(checkboxData.content)}
                value={"login-remember_me"}
                handleChange={() => {
                  setCheckboxAccepted(!checkboxAccepted);
                }}
                checked={checkboxAccepted}
              />
            </div>
            <button
              className="cookies-modal__button terms-modal__init-close"
              onClick={closeModal}
            >
              Zapisz
            </button>
          </form>
          {modalBottomContent && ReactHtmlParser(modalBottomContent.content)}
        </div>
      </div>
    </div>
  );
};

export default Modal;
